// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Tabs-module--cls1--11Qq3"};